// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.role-selection-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
}

.role-selection-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.role-selection-field label {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.role-selection-field select {
    width: 100%;
    min-height: 56px;
    padding: 0 16px;

    font-size: 18px;
    font-weight: 500;

    background-color: #fff;
    border: 1px solid #c5c5c5;
    border-radius: 8px;

    cursor: pointer;
    outline: none;
}

.role-selection-field select:focus {
    border-color: #013868;
    box-shadow: 0 0 0 2px rgba(1, 56, 104, 0.15);
}

.item-list-actions {
    margin-top: 28px;
}`, "",{"version":3,"sources":["webpack://./src/web/component/SelectRoleOdmraz/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;;IAEf,eAAe;IACf,gBAAgB;;IAEhB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;;IAElB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".role-selection-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 24px;\r\n    width: 100%;\r\n    max-width: 600px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.role-selection-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    width: 100%;\r\n}\r\n\r\n.role-selection-field label {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #333;\r\n}\r\n\r\n.role-selection-field select {\r\n    width: 100%;\r\n    min-height: 56px;\r\n    padding: 0 16px;\r\n\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n\r\n    background-color: #fff;\r\n    border: 1px solid #c5c5c5;\r\n    border-radius: 8px;\r\n\r\n    cursor: pointer;\r\n    outline: none;\r\n}\r\n\r\n.role-selection-field select:focus {\r\n    border-color: #013868;\r\n    box-shadow: 0 0 0 2px rgba(1, 56, 104, 0.15);\r\n}\r\n\r\n.item-list-actions {\r\n    margin-top: 28px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
